import { CardsContext } from '@views/contexts'
import { useContext } from 'react'

export const useCards = () => useContext(CardsContext)
